module.exports = __webpack_public_path__ + "images/87711407412494d529d45ee76167583c.svg";